import { AutogenModelCarrier, AutogenRowCarrier } from "./autogen/AutogenModelCarrier";

export class ModelCarrier extends AutogenModelCarrier<RowCarrier> {
    constructor() {
        super(RowCarrier);
    }
}

export class RowCarrier extends AutogenRowCarrier {
}